import { Address } from '@/dataV3/Common/Address'
import { PendingAcquisitionUser } from '@/dataV3/User/PendingAcquisitionUser'
import { AuthReturn } from '@/modules/Auth/apiTypes/base'
import { APIRoute } from '@/modules/utils'
import { PureObject } from 'emt-library'

export type PetOwnerBody = {
  firstName: string
  lastName: string
  email: string
  password: {
    password: string
    passwordConfirmation: string
  }
  confirmTerms: boolean
  address: PureObject<Address>
  phone: string
  optins: string[]
  tendersEnabled?: boolean | null
}

export type BorrowerBody = {
  firstName: string
  lastName: string
  email: string
  password: {
    password: string
    passwordConfirmation: string
  }
  confirmTerms: boolean
}

export type PetSitterBody = {
  email: string
  password: string
  passwordConfirmation?: string
  firstname: string
  lastname: string
  confirmMajority?: boolean
  confirmToU?: boolean
}

export type Body =
  | {
      type: 'petowner'
      body: PetOwnerBody
    }
  | {
      type: 'borrower'
      body: BorrowerBody
    }
  | {
      type: 'petsitter'
      body: PetSitterBody
    }

export type Response = PendingAcquisitionUser & AuthReturn

export const PetOwnerRoute: APIRoute = {
  method: 'POST',
  path: '/acquisition/members/petowners',
}

export const BorrowerRoute: APIRoute = {
  method: 'POST',
  path: '/acquisition/members/borrower',
}

export const PetSitterRoute: APIRoute = {
  method: 'POST',
  path: '/v2/petsitter_registrations',
}
